/**
 * Confirmation modal shown when an Ops user selects "Submit" from the Actions
 * dropdown while reviewing a Requested Expense Inventory case. Finalizes every
 * line's current Approve/Reject/Manual decision in one reviewExpenseInventory
 * call (submit:true).
 * @module src/components/Inventory/expense/detail/SubmitReviewModal
 */
import React, { FC } from 'react';
import Modal from '@salesforce/design-system-react/components/modal';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import Spinner from '@salesforce/design-system-react/components/spinner';
import Button from '@salesforce/design-system-react/components/button';

interface Props {
  isOpen: boolean;
  caseNumber?: string;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const SubmitReviewModal: FC<Props> = ({
  isOpen,
  caseNumber,
  loading = false,
  onClose,
  onConfirm,
}) => {
  return (
    <IconSettings iconPath="/icons">
      <Modal
        isOpen={isOpen}
        onRequestClose={onClose}
        dismissOnClickOutside={false}
        ariaHideApp={false}
        heading={
          <div className="slds-float_left slds-text-title_bold slds-text-heading_medium">
            {`Expense Inventory ${caseNumber || ''}`}
          </div>
        }
        footer={[
          <div className="slds-align_absolute-center" key="submit_review_expense_inventory">
            {loading && (
              <Spinner size="small" variant="base" assistiveText={{ label: 'Submitting...' }} />
            )}
            <Button label="No" onClick={onClose} />
            <Button style={{ backgroundColor: '#ffb501' }} label="Yes" onClick={onConfirm} />
          </div>,
        ]}
      >
        <section>
          <div style={{ position: 'relative', padding: '1rem' }}>
            {`Are you sure you want to submit this Expense Inventory review? This will finalize the Approve/Reject/Manual decisions for every part.`}
          </div>
        </section>
      </Modal>
    </IconSettings>
  );
};

/** Submit Review confirmation modal **/
export default SubmitReviewModal;
